const isUndefined = require("lodash/isUndefined");
/**
 * Initialise with a cache that returns a cached Promise on get/set.
 *
 * Returns a method that when executed with a key and a method that returns a promise
 * will first query the cache using the key. if no promise is found will invoke
 * the method and cache the promise returned
 *
 * This enables request collapsing by caching the promise instead of the value.
 */

module.exports = (cache) => (key, methodThatReturnsAPromise) => {
  const cachedValue = cache.get(key);
  if (!isUndefined(cachedValue)) {
    return cachedValue;
  }
  const valueToCache = methodThatReturnsAPromise();
  cache.set(key, valueToCache);
  valueToCache.catch(() => cache.del(key));
  return valueToCache;
};
